import React from "react";
import './Purchase.css';


export default function Purchase() {
    return (
        <div className="purchase-page-wrapper">
            <h2>Thank you!</h2>
            Send us a message @ <a className="email-link" href= "mailto: MaldeveraTX@gmail.com">MaldeveraTX@gmail.com</a> to confirm size and address.
        </div>
    )
}